module.exports = __webpack_public_path__ + "img/router-line.d0d76729.svg";